import { render } from "./Basic.vue?vue&type=template&id=a63dcd90&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"

import "./Basic.vue?vue&type=style&index=0&id=a63dcd90&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a63dcd90"

export default script